<div fxLayoutGap="10px" fxLayout="column" class="search-dialog" (click)="$event.stopPropagation()">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
    <mat-tab label="Play Executions">
      @if (playExecutionForm) {
        <form [formGroup]="playExecutionIdFormGroup" (ngSubmit)="searchByPlayExecutionId()">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="search-controls">
            <bt-form-field fxFlex="300px">
              <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Play Execution ID</mat-label>
                <input type="number" formControlName="id" matInput/>
              </mat-form-field>
            </bt-form-field>
            <button matButton="filled" type="submit" [disabled]="playExecutionIdFormGroup.value?.id === null">
              Search
            </button>
            @if (playExecutionNoResults) {
              <span class="no-results">No results found.</span>
            }
          </div>
        </form>
      }
      <mat-table #table [dataSource]="playExecutionDataTable">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef> ID</mat-header-cell>
          <mat-cell *matCellDef="let playExecution">
            <a routerLink="/stores/{{ playExecution.storeId }}/{{
                playExecution?.jobType === 'insight'
                  ? 'insight'
                  : playExecution?.jobType === 'rfid'
                    ? 'rfid'
                    : 'inspect'
              }}/play-executions/{{ playExecution.id }}" class="clickable">{{ playExecution.id }}
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="play">
          <mat-header-cell *matHeaderCellDef> Play</mat-header-cell>
          <mat-cell *matCellDef="let playExecution">
            <div fxLayout="row" fxLayoutGap="10px">
              <div fxLayoutAlign="center center">
                <mat-icon color="primary" [svgIcon]="
                    playExecution?.jobType === 'insight'
                      ? 'insight_marty'
                      : playExecution?.jobType === 'rfid'
                        ? 'rfid_bot'
                        : 'inspect_marty'
                  "></mat-icon>
              </div>
              <div fxLayout="column">
                <a routerLink="/stores/{{ playExecution.storeId }}/{{
                    playExecution?.jobType === 'insight'
                      ? 'insight'
                      : playExecution?.jobType === 'rfid'
                        ? 'rfid'
                        : 'inspect'
                  }}/play-executions/{{ playExecution.id }}" class="clickable">{{ playExecution.play?.name }}
                </a>
                <div matTooltip="{{
                    getMainDateTimeString(
                      playExecution.startTime,
                      playExecution.store
                    )
                  }}" class="search-result-subtext">
                  {{ playExecution.startTime | date: "short" }}
                </div>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="store">
          <mat-header-cell *matHeaderCellDef> Store</mat-header-cell>
          <mat-cell *matCellDef="let playExecution">
            <div fxLayout="column">
              <a routerLink="/stores/{{ playExecution.storeId }}" class="clickable">{{ playExecution.store?.name }}
              </a>
              <div class="search-result-subtext">
                {{ playExecution.robot?.name }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="details">
          <mat-header-cell *matHeaderCellDef> Details</mat-header-cell>
          <mat-cell *matCellDef="let playExecution">
            @if (playExecution.jobType === "insight") {
              <div fxLayoutGap="5px" fxLayoutAlign="start center">
                <mat-icon [ngClass]="
                    playExecution.playOptions?.play_outputs?.includes(
                      'hole_oos'
                    )
                      ? 'hole_oos'
                      : 'issue-disabled'
                  " [svgIcon]="'hole_oos_alt'"></mat-icon>
                <mat-icon [ngClass]="
                    playExecution.playOptions?.play_outputs?.includes('eOOS')
                      ? 'eOOS'
                      : 'issue-disabled'
                  " [svgIcon]="'eOOS_alt'"></mat-icon>
                <mat-icon [ngClass]="
                    playExecution.playOptions?.play_outputs?.includes(
                      'price_mismatch'
                    )
                      ? 'price_mismatch'
                      : 'issue-disabled'
                  " [svgIcon]="'price_mismatch_alt'"></mat-icon>
                <mat-icon [ngClass]="
                    playExecution.playOptions?.play_outputs?.includes(
                      'sale_price_mismatch'
                    )
                      ? 'sale_price_mismatch'
                      : 'issue-disabled'
                  " [svgIcon]="'sale_price_mismatch_alt'"></mat-icon>
                <mat-icon [ngClass]="
                    playExecution.playOptions?.play_outputs?.includes(
                      'top_stock'
                    )
                      ? 'top_stock'
                      : 'issue-disabled'
                  " [svgIcon]="'top_stock_alt'"></mat-icon>
              </div>
            } @else if (playExecution.jobType === "cleansweep") {
              <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
                <div fxLayout="column">
                  <div>Hazards: {{ playExecution.hazardCount }}</div>
                  <div>Urgents: {{ playExecution.urgentCount }}</div>
                </div>
                <div fxLayoutAlign="start center">
                  @if (!idsGenerating.includes(playExecution.id)) {
                    <button [ngClass]="playExecution.urgentCount === 0 ? 'hidden' : ''" mat-icon-button matTooltip="Download Urgent Report" (click)="downloadUrgentReport(playExecution.id)">
                      <mat-icon color="primary">file_download</mat-icon>
                    </button>
                  } @else {
                    <mat-spinner class="urgent-spinner" [diameter]="20"></mat-spinner>
                  }
                </div>
              </div>
            }
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="playExecutionDataTable?.displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: playExecutionDataTable?.displayedColumns"></mat-row>
      </mat-table>
    </mat-tab>

    <mat-tab label="InSight Scans">
      @if (scanEventForm) {
        <form [formGroup]="scanEventIdFormGroup" (ngSubmit)="searchByScanEventId()">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="search-controls">
            <bt-form-field fxFlex="300px">
              <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Scan Event ID</mat-label>
                <input min="0" type="number" formControlName="scan_event_id" matInput/>
              </mat-form-field>
            </bt-form-field>
            <button mat-flat-button color="primary" type="submit" [disabled]="(scanEventIdFormGroup.value?.scan_event_id ?? null) === null">
              Search
            </button>
            @if (scanEventNoResults) {
              <span class="no-results">No results found.</span>
            }
          </div>
        </form>
      }
      <mat-table #table [dataSource]="scanEventDataTable">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef> ID</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <a routerLink="/stores/{{
                data.playExecution?.storeId
              }}/insight/play-executions/{{
                data.playExecution?.id
              }}/scan-events/{{ data.scanEventId }}" class="clickable">{{ data.scanEventId }}
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="store">
          <mat-header-cell *matHeaderCellDef> Store</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <div fxLayout="column">
              <a routerLink="/stores/{{ data.playExecution?.storeId }}" class="clickable">{{ data.playExecution?.store?.name }}
              </a>
              <div class="search-result-subtext">
                {{ data.playExecution?.robot?.name }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="play">
          <mat-header-cell *matHeaderCellDef> Play</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <div fxLayout="row" fxLayoutGap="10px">
              <div fxLayoutAlign="center center">
                <mat-icon color="primary" [svgIcon]="'insight_marty'"></mat-icon>
              </div>
              <div fxLayout="column">
                <a routerLink="/stores/{{
                    data.playExecution?.storeId
                  }}/insight/play-executions/{{ data.playExecution?.id }}" class="clickable">{{ data.playExecution?.play?.name }}</a>
                <div matTooltip="{{
                    getMainDateTimeString(
                      data.playExecution?.startTime,
                      data.playExecution?.store
                    ) }}" class="search-result-subtext">
                  {{ data.playExecution?.startTime | date: "short" }}
                </div>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="aisle">
          <mat-header-cell *matHeaderCellDef> Aisle</mat-header-cell>
          <mat-cell *matCellDef="let data">
            @if (getScanEvent(data.playExecution, data.scanEventId);
              as scanEvent) {
              <div fxLayout="column">
                <a routerLink="/stores/{{
                    data.playExecution?.storeId
                  }}/insight/play-executions/{{
                    data.playExecution?.id
                  }}/scan-events/{{ data.scanEventId }}" class="clickable">{{ scanEvent.description }}
                </a>
                <div matTooltip="{{
                    getMainDateTimeString(
                      scanEvent.startedAt,
                      scanEvent.playExecution?.store
                    )
                  }}" class="search-result-subtext">
                  {{ scanEvent.startedAt | date: "short" }}
                </div>
              </div>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="details">
          <mat-header-cell *matHeaderCellDef> Details</mat-header-cell>
          <mat-cell *matCellDef="let scanEvent">
            <div fxLayoutGap="5px" fxLayoutAlign="start center">
              <mat-icon [ngClass]="
                  scanEvent.playExecution?.playOptions?.play_outputs?.includes(
                    'hole_oos'
                  )
                    ? 'hole_oos'
                    : 'issue-disabled'
                " [svgIcon]="'hole_oos_alt'"></mat-icon>
              <mat-icon [ngClass]="
                  scanEvent.playExecution?.playOptions?.play_outputs?.includes(
                    'eOOS'
                  )
                    ? 'eOOS'
                    : 'issue-disabled'
                " [svgIcon]="'eOOS_alt'"></mat-icon>
              <mat-icon [ngClass]="
                  scanEvent.playExecution?.playOptions?.play_outputs?.includes(
                    'price_mismatch'
                  )
                    ? 'price_mismatch'
                    : 'issue-disabled'
                " [svgIcon]="'price_mismatch_alt'"></mat-icon>
              <mat-icon [ngClass]="
                  scanEvent.playExecution?.playOptions?.play_outputs?.includes(
                    'sale_price_mismatch'
                  )
                    ? 'sale_price_mismatch'
                    : 'issue-disabled'
                " [svgIcon]="'sale_price_mismatch_alt'"></mat-icon>
              <mat-icon [ngClass]="
                  scanEvent.playExecution?.playOptions?.play_outputs?.includes(
                    'top_stock'
                  )
                    ? 'top_stock'
                    : 'issue-disabled'
                " [svgIcon]="'top_stock_alt'"></mat-icon>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="scanEventDataTable?.displayedColumns "></mat-header-row>
        <mat-row *matRowDef="let row; columns: scanEventDataTable?.displayedColumns"></mat-row>
      </mat-table>
    </mat-tab>

    <mat-tab label="Capture Events">
      @if (captureEventForm) {
        <form [formGroup]="captureEventIdFormGroup" (ngSubmit)="searchByCaptureId()">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="search-controls">
            <bt-form-field fxFlex="300px">
              <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Capture Event ID</mat-label>
                <input min="0" type="number" formControlName="capture_event_id" matInput/>
              </mat-form-field>
            </bt-form-field>
            <button mat-flat-button color="primary" type="submit" [disabled]="(captureEventIdFormGroup.value?.capture_event_id ?? null) === null">
              Search
            </button>
            @if (captureEventNoResults) {
              <span class="no-results">No results found.</span>
            }
          </div>
        </form>
      }
      <mat-table #table [dataSource]="captureEventDataTable">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef> ID</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <a routerLink="/stores/{{
                data.playExecution.storeId
              }}/inspect/play-executions/{{ data.playExecution.id }}" [queryParams]="{ 'capture-event-id': data.captureEventId }" class="clickable">{{ data.captureEventId }}
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="play">
          <mat-header-cell *matHeaderCellDef> Play</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <div fxLayout="row" fxLayoutGap="10px">
              <div fxLayoutAlign="center center">
                <mat-icon color="primary" [svgIcon]="'inspect_marty'"></mat-icon>
              </div>
              <div fxLayout="column">
                <a routerLink="" [queryParams]="{ 'capture-event-id': data.captureEventId }" (click)="onCaptureEventClick(data.captureEventId)" class="clickable">{{ data.playExecution.play?.name }}</a>
                <div matTooltip="{{
                    getMainDateTimeString(
                      data.playExecution.startTime,
                      data.playExecution.store
                    )
                  }}" class="search-result-subtext">
                  {{ data.playExecution.startTime | date: "short" }}
                </div>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="store">
          <mat-header-cell *matHeaderCellDef> Store</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <div fxLayout="column">
              <a routerLink="/stores/{{ data.playExecution?.storeId }}" class="clickable">{{ data.playExecution?.store?.name }}
              </a>
              <div class="search-result-subtext">
                {{ data.playExecution?.robot?.name }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef> Details</mat-header-cell>
          <mat-cell *matCellDef="let data">
            @if (getCaptureEvent(data.playExecution, data.captureEventId);
              as captureEvent) {
              <div fxLayout="row" fxLayoutGap="10px">
                @if (captureEvent.status === "urgent") {
                  <div matTooltip="Urgent" fxLayoutAlign="center center">
                    <mat-icon color="warn">warning</mat-icon>
                  </div>
                }
                @if (captureEvent.status === "hazardOnly") {
                  <div matTooltip="Hazard only" fxLayoutAlign="center center">
                    <mat-icon class="hazard-only-icon">warning</mat-icon>
                  </div>
                }
                <div>
                  {{ captureEvent.getReviewDetails().join(", ") }}
                </div>
              </div>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="details">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let data">
            @if (getCaptureEvent(data.playExecution, data.captureEventId);
              as captureEvent) {
              <div fxLayout="column">
                <div>{{ captureEvent.zoneDescription }}</div>
                <div matTooltip="{{
                    getMainDateTimeString(
                      captureEvent.capturedAt,
                      data.playExecution.store
                    )
                  }}" class="search-result-subtext">
                  {{ captureEvent.capturedAt | date: "short" }}
                </div>
              </div>
            }
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="captureEventDataTable?.displayedColumns"></mat-header-row>

        <mat-row *matRowDef="let row;columns: captureEventDataTable?.displayedColumns"></mat-row>
      </mat-table>
    </mat-tab>

    <mat-tab label="RFID Scans">
      @if (rfidScanEventForm) {
        <form [formGroup]="rfidEventIdFormGroup" (ngSubmit)="searchByRfidScanEventId()">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="search-controls">
            <bt-form-field fxFlex="300px">
              <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
                <mat-label>RFID Scan Event ID</mat-label>
                <input min="0" type="number" formControlName="rfid_scan_event_id" matInput/>
              </mat-form-field>
            </bt-form-field>
            <button mat-flat-button color="primary" type="submit" [disabled]="
                rfidEventIdFormGroup.value?.rfid_scan_event_id === null
              ">
              Search
            </button>
            @if (rfidScanEventNoResults) {
              <span class="no-results">No results found.</span>
            }
          </div>
        </form>
      }
      <mat-table #table [dataSource]="rfidScanEventDataTable">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef> ID</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <a routerLink="/stores/{{
                data.playExecution?.storeId
              }}/rfid/play-executions/{{ data.playExecution?.id }}" class="clickable">{{ data.rfidScanEventId }}</a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="store">
          <mat-header-cell *matHeaderCellDef> Store</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <div fxLayout="column">
              <a routerLink="/stores/{{ data.playExecution?.storeId }}" class="clickable">{{ data.playExecution?.store?.name }}
              </a>
              <div class="search-result-subtext">
                {{ data.playExecution?.robot?.name }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="play">
          <mat-header-cell *matHeaderCellDef> Play</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <div fxLayout="row" fxLayoutGap="10px">
              <div fxLayoutAlign="center center">
                <mat-icon color="primary" [svgIcon]="'rfid_bot'"></mat-icon>
              </div>
              <div fxLayout="column">
                <a routerLink="/stores/{{ data.playExecution?.storeId }}/rfid/play-executions/{{ data.playExecution?.id }}" class="clickable">{{ data.playExecution?.play?.name }}</a>
                <div matTooltip="{{ getMainDateTimeString(
                     data.playExecution?.startTime,
                     data.playExecution?.store) }}" class="search-result-subtext">
                  {{ data.playExecution?.startTime | date: "short" }}
                </div>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tagCount">
          <mat-header-cell *matHeaderCellDef> Tag Count</mat-header-cell>
          <mat-cell *matCellDef="let data">
            <div fxLayout="column">
              {{
                getRfidScanEvent(data.playExecution, data.rfidScanEventId)
                  ?.tagCount
              }}
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef=" rfidScanEventDataTable?.displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: rfidScanEventDataTable?.displayedColumns"></mat-row>
      </mat-table>
    </mat-tab>
  </mat-tab-group>
</div>
